import { ReactElement, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from 'beam'
import { Paper } from 'beam/dist/Paper'
import { LanguageDropdown } from '../LanguageDropdown'
import Footer from '../Footer'

const useStyles = makeStyles(theme => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100vh - ${theme.spacing(6)}px)`,
  },
  pageFiller: {
    flex: '1 1 auto',
    paddingBottom: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  centeredBox: {
    padding: theme.spacing(2, 5),
    minWidth: theme.spacing(65),
    marginBottom: theme.spacing(1),
  },
  ssoButton: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    lineHeight: '1.5em',
    minHeight: theme.spacing(5),
    fontWeight: 'normal',
  },
}))

export interface AuthLayoutProps {
  children: ReactNode,
}

export function AuthLayout({ children }: AuthLayoutProps): ReactElement {
  const classes = useStyles()
  const { i18n } = useTranslation()
  return (
    <div className={classes.root}>
      <div className={classes.pageFiller}>
        <div>
          <Paper className={classes.centeredBox}>{children}</Paper>
          <LanguageDropdown language={i18n.language} onChange={newLang => i18n.changeLanguage(newLang)} />
        </div>
      </div>
      <Footer />
    </div>
  )
}
